import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { StockProvider } from "@/context/StockContext";
import { Header } from "@/components/lumi/Header";
import { Footer } from "@/components/lumi/Footer";
import { CartDrawer } from "@/components/lumi/CartDrawer";
import { SmoothScroll } from "@/components/lumi/SmoothScroll";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import Admin from "@/pages/Admin";
import ReviewPage from "@/pages/ReviewPage";
import { PaymentCancel, PaymentSuccess } from "@/pages/PaymentResult";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      <SmoothScroll />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/review/:token" element={<ReviewPage />} />
        <Route path="*" element={<Home />} />
      </Routes>
      {!isAdmin && <Footer />}
      <CartDrawer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StockProvider>
        <CartProvider>
          <Shell />
          <Toaster position="bottom-center" toastOptions={{ style: { background: "#281715", color: "#FAF7F2", border: "none", borderRadius: "999px" } }} />
        </CartProvider>
        </StockProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
